import React, { useState } from 'react';
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'
import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/react";
import { useMatomo } from './components/useMatomo';

import './style.css'
import CookieConsent from "./components/cookie-banner";
import PrivacyPolicyPage from './views/privacy-policy-page'
import Home from './views/home'
import ImpressumPage from './views/impressum-page'
import Page from './views/page'

Sentry.init({
  dsn: "https://f1149e605a278cd69b92af4a3556225c@o4509593220415488.ingest.de.sentry.io/4509625362939984", 
  integrations: [browserTracingIntegration()],
  tracesSampleRate: 1.0,
});

Sentry.captureMessage("Wichtige Info oder Warning", "info");


const App = () => {
  const [trackingAllowed, setTrackingAllowed] = useState(false);
  useMatomo(trackingAllowed);
  return (
    <>
      <CookieConsent onAccept={() => setTrackingAllowed(true)} />
      <Router>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/privacy-policy" component={PrivacyPolicyPage} />
          <Route exact path="/impressum" component={ImpressumPage} />
          
          {/* Fallback für alle nicht definierten Routen */}
          <Route component={Page} />
        </Switch>
      </Router>
    </>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
